import { render, staticRenderFns } from "./BillPaymentTwo.vue?vue&type=template&id=1b402fcb"
import script from "./BillPaymentTwo.vue?vue&type=script&lang=js"
export * from "./BillPaymentTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports